import { render, staticRenderFns } from "./imgInfo.vue?vue&type=template&id=5556da86&scoped=true&"
import script from "./imgInfo.vue?vue&type=script&lang=js&"
export * from "./imgInfo.vue?vue&type=script&lang=js&"
import style0 from "./imgInfo.vue?vue&type=style&index=0&id=5556da86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556da86",
  null
  
)

export default component.exports